module.exports = __webpack_public_path__ + "files/4797f291d8616a0470b2c6a1ce64aadc.png";